import { rebindEvent, requestOptional, } from "scripts/Utilities/core";

let searchTimer : number;

function init() {
    rebindEvent("click", ".searchByWord-js", searchFaq);
    rebindEvent("input", ".searchByInput-js", onSearchInput);
}

function searchFaq(e): void {
    e.preventDefault();
    let wrapper = $(e.currentTarget).closest(".faq-tab-wrapper");
    let word = e.target.value as string;
    let categoryid = wrapper.find("#CategoryId").val();

    requestOptional(
        "Search",
        "Faq",
        {
            type: "POST",
            useArea: false,
            data: {
                categoryid: categoryid,
                searchword: word
            },
            success: (res) => {
                wrapper.find("#faq-result").html(res);
            }
        });
}

function onSearchInput(e): void {
    clearTimeout(searchTimer);

    searchTimer = window.setTimeout(() => {

        let word = e.target.value as string;
        if (!word) {
            searchFaq(e);
            return;
        }

        if (word.length < 3) {
            return;
        }

        searchFaq(e);

    }, 500);
}

init();
